if (!customElements.get('natunora-listicle-testimonials')) {
  customElements.define('natunora-listicle-testimonials', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.view = this.querySelector('.n-listicle-testimonials__view');
      this.cards = [...this.querySelectorAll('.n-listicle-testimonials__card')];
      this.controls = this.querySelector('.n-listicle-testimonials__controls');
      this.status = this.querySelector('[role="status"]');
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-step]');
        if (button) this.move(Number(button.dataset.step));
      }, options);
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.scrollTo(0);
        else if (event.key === 'End') this.scrollTo(this.maximum());
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.view.addEventListener('scroll', () => {
        clearTimeout(this.announceTimer);
        this.announceTimer = setTimeout(() => this.announce(), 250);
      }, { ...options, passive: true });
      for (const type of ['pointerdown', 'wheel']) {
        this.view.addEventListener(type, () => this.cancel(), { ...options, passive: true });
      }
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.n-listicle-testimonials__card');
        if (card) this.scrollTo(card.getBoundingClientRect().left - this.view.getBoundingClientRect().left + this.view.scrollLeft);
      }, options);
      this.resize = new ResizeObserver(() => {
        this.cancel();
        this.controls.hidden = this.maximum() < 2;
      });
      this.resize.observe(this.view);
    }

    maximum() { return Math.max(0, this.view.scrollWidth - this.view.clientWidth); }

    move(direction) {
      if (!this.cards.length) return;
      const current = this.target ?? this.view.scrollLeft;
      const gap = parseFloat(getComputedStyle(this.cards[0].parentElement).gap) || 0;
      const step = this.cards[0].getBoundingClientRect().width + gap;
      const max = this.maximum();
      const target = direction > 0 ? (current >= max - 2 ? 0 : current + step) : (current <= 2 ? max : current - step);
      this.scrollTo(target);
    }

    scrollTo(target) {
      this.cancel();
      this.target = Math.max(0, Math.min(target, this.maximum()));
      const start = this.view.scrollLeft;
      const end = this.target;
      const value = getComputedStyle(this).getPropertyValue('--natunora-motion-duration').trim();
      const duration = parseFloat(value) * (value.endsWith('ms') ? 1 : 1000) || 0;
      if (!duration || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.view.scrollLeft = end;
        this.target = null;
        this.announce();
        return;
      }
      this.view.style.scrollSnapType = 'none';
      const started = performance.now();
      const frame = now => {
        const progress = Math.min((now - started) / duration, 1);
        this.view.scrollLeft = start + (end - start) * this.ease(progress);
        if (progress < 1) this.frame = requestAnimationFrame(frame);
        else { this.cancel(); this.announce(); }
      };
      this.frame = requestAnimationFrame(frame);
    }

    ease(x) {
      let low = 0, high = 1, t = x;
      for (let i = 0; i < 12; i++) {
        const estimate = 3 * (1 - t) ** 2 * t * 0.25 + 3 * (1 - t) * t ** 2 * 0.25 + t ** 3;
        if (estimate < x) low = t; else high = t;
        t = (low + high) / 2;
      }
      return 3 * (1 - t) ** 2 * t * 0.1 + 3 * (1 - t) * t ** 2 + t ** 3;
    }

    cancel() {
      cancelAnimationFrame(this.frame);
      this.target = null;
      if (this.view) this.view.style.removeProperty('scroll-snap-type');
    }

    announce() {
      const view = this.view.getBoundingClientRect();
      const visible = this.cards.map((card, index) => ({ rect: card.getBoundingClientRect(), index }))
        .filter(({ rect }) => rect.left >= view.left - 2 && rect.right <= view.right + 2);
      if (!visible.length) return;
      const first = visible[0].index + 1;
      const last = visible[visible.length - 1].index + 1;
      this.status.textContent = `Kundenstimmen ${first === last ? first : `${first} bis ${last}`} von ${this.cards.length}`;
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      clearTimeout(this.announceTimer);
      this.cancel();
    }
  });
}
